/**
 * Step 13 — Journey summary + What's waiting
 *
 * Spec: specs/onboarding-rebuild.md → Act 3 step 13
 *
 * Trading-card deck (front identity card + back "By the numbers" stats).
 * Variant scaffolding retired 2026-05-14 — synthesis is production. The
 * synthesis-map (constellation) alternative was deleted with it.
 */

import JourneySummarySynthesis from './JourneySummary.synthesis'

export default function JourneySummaryStep({ profile, ministryMapSeeded, stats, onContinue }) {
  return (
    <JourneySummarySynthesis
      profile={profile}
      ministryMapSeeded={ministryMapSeeded}
      stats={stats}
      onContinue={onContinue}
    />
  )
}
